import React from 'react';
import './index.css';

export const Label28 = ({ bold=false, children }) => {
    const textStyle =  { fontWeight: (bold) ? '600': 'normal' };
    return <label className="label28" style={textStyle}>{children}</label>;
};